<template>
  <b-container class="pad-bottom--xl pad-top--sm">
    <component v-bind:is="crmData.type"
      :crmData='crmData'
      @deleteData="deleteCRM"
      @save='saveCrm'
      @close="closeWidget">
    </component>
  </b-container >
</template>
<script>
import CrmDynamics from '@/components/CrmDynamics.vue'
import CrmSalesforce from '@/components/CrmSalesforce.vue'

export default {
  name: 'CRMMap',
  components: {
    'dynamics': CrmDynamics,
    'salesforce': CrmSalesforce
  },
  props: {
    crmData: {
      type: Object
    }
  },
  data () {
    return {}
  },
  methods: {
    deleteCRM () {
      this.$emit('deleteData')
    },
    saveCrm (value) {
      this.$emit('save', value)
    },
    closeWidget () {
      this.$emit('close')
    }
  }
}
</script>
